import { createFileRoute } from '@tanstack/react-router';
import { MenuTitle } from '../../types';

export const influencersStaticData = {
  menuTitle: MenuTitle.Influencers
};

export const Route = createFileRoute('/_private-routes/influencers')({
  staticData: influencersStaticData
});
